import { _api } from '@/utils/apiAxios';
import { find } from 'lodash';
import get from 'lodash/get';
import { getField, updateField } from 'vuex-map-fields';
import { updateBetLineOdds, updateBetLineOutcome } from './socket-utils';

const state = {
  status: { loading: false },
  propsData: null,
  propsScore: null,
  statsGameData: {},
  propsParams: {},
};
const getters = {
  visitingTeamAbbr: state => {
    // let keys = Object.keys(state.statsGameData.originalResponse)
    return state.statsGameData.originalResponse['visiting-team']['team-name']['abbreviation'];
  },
  homeTeamAbbr: state => {
    // let keys = Object.keys(state.statsGameData.originalResponse)
    return state.statsGameData.originalResponse['home-team']['team-name']['abbreviation'];
  },
};
const mutations = {
  initializing: state => {
    state.status = { loading: true };
  },
  requestSuccess: (state, data) => {
    state.propsData = data;
  },
  requestEnded: (state, data) => {
    state.status = { loading: false };
  },
  setPropsScore: (state, data) => {
    state.propsScore = data;
  },
  setPropsStats: (state, value) => {
    state.statsGameData = value;
  },
  setPropsParams: (state, value) => {
    state.propsParams = value;
  },
};
const actions = {
  setPropsEmpty: ({ commit, dispatch, rootState }) => {
    commit('requestSuccess', null);
  },
  getPropsByGame: ({ commit, dispatch, rootState }, gameId) => {
    if (gameId === '') return;
    commit('initializing');
    commit('requestSuccess', null);
    return _api
      .post('/game/getGamesWithOdds', {
        gameId: gameId,
        idLanguage: rootState.settings.selectedLocale.id,
        lineStyle: rootState.settings.selectedOddType,
        isLive: false,
        utc: rootState.settings.timeZone.code,
      })
      .then(res => {
        if (res.data.IsSuccess) {
          const data = res.data.Data ? res.data.Data : [];
          commit('requestSuccess', data);
        }
      })
      .finally(() => {
        commit('requestEnded');
        commit('setPropsStats', {});
      });
  },
  getPropsLiveScore: ({ commit, state, rootState }, eventId) => {
    if (!eventId) return;
    _api
      .get('/game/getlivescores?' + 'lang=' + rootState.settings.selectedLocale.id + '&brgameids=' + eventId)
      .then(r => {
        if (r.data.IsSuccess) {
          var propsGame = state.propsData;
          var liveScores = r.data.Data;
          if (liveScores && liveScores.length > 0) {
            var brGame = liveScores[0];
            if (brGame.game_status === 3) return;
            commit('setPropsScore', brGame);
          } else {
            commit('setPropsScore', null);
          }
        }
      });
  },
  setSocketData({ commit, rootState, state, dispatch }, data) {
    const selectedOddType = rootState.settings.selectedOddType;
    const propsData = state.propsData;
    if (!propsData) return;
    let gameFind = data.find(g => g.ghid == propsData.id);
    if (!gameFind) return;
    data.forEach(socketDat => {
      for (const type in propsData.gameMarkets) {
        const chunk = propsData.gameMarkets[type];
        chunk.forEach(market => {
          socketDat.omdl.forEach(socketOutcome => {
            if (market.MoneyLine) {
              market.MoneyLine.forEach(ml => {
                let checkMarket = socketOutcome.oid == ml.id;
                if (checkMarket) {
                  updateBetLineOdds(ml, socketOutcome.pts, socketOutcome.odd, selectedOddType, 'moneyLine');
                }
              });
            }
            if (market.Spread) {
              market.Spread.forEach(sp => {
                let checkMarket = socketOutcome.oid == sp.id;
                if (checkMarket) {
                  updateBetLineOdds(sp, socketOutcome.pts, socketOutcome.odd, selectedOddType, 'spread');
                }
              });
            }
            if (market.Total) {
              market.Total.forEach(to => {
                let checkMarket = socketOutcome.oid == to.id;
                if (checkMarket) {
                  updateBetLineOdds(to, socketOutcome.pts, socketOutcome.odd, selectedOddType, 'total');
                }
              });
            }
            if (market.Special) {
              market.Special.forEach(ml => {
                let checkMarket = socketOutcome.oid == ml.id;
                if (checkMarket) {
                  updateBetLineOdds(ml, socketOutcome.pts, socketOutcome.odd, selectedOddType, 'moneyLine');
                }
              });
            }

          });

        });
      }
    });

    // for (const type in propsData.gameMarkets) {
    //   const chunk = propsData.gameMarkets[type];

    //   chunk.forEach(gameMarket => {
    //     debugger;
    //     gameMarket.MoneyLine.forEach(m => {
    //       //checkMoneyline
    //       let moneyLineFind = data.find(m => m.gmid == m.gameMarketId);
    //       if (moneyLineFind) {

    //         updateBetLineOdds(m, moneyLineFind.pts, moneyLineFind.odd, selectedOddType, 'moneyLine');
    //       }
    //     });
    //     gameMarket.Spread.forEach(m => {
    //       //checkSpread
    //       let spreadLineFind = data.find(m => m.gmid == m.gameMarketId);
    //       if (spreadLineFind) {
    //         updateBetLineOdds(m, spreadLineFind.pts, spreadLineFind.odd, selectedOddType, 'spread');
    //       }
    //     });
    //     gameMarket.Total.forEach(m => {
    //       //checkTotalLine
    //       let totalLineFind = data.find(m => m.gmid == m.gameMarketId);
    //       if (totalLineFind) {
    //         updateBetLineOdds(m, totalLineFind.pts, totalLineFind.odd, selectedOddType, 'total');
    //       }
    //     });
    //   });

    // data.map(newItem => {
    //   chunk.propsHeaders.map(header => {
    //     for (const keyHeader in header.props) {
    //       const prop = header.props[keyHeader];
    //       if (!prop) continue;
    //       for (const key in prop.odds) {
    //         const oddType = prop.odds[key];
    //         if (!oddType) continue;
    //         if (key === 'special_money_lines') {
    //           const tournament = oddType.tournament;
    //           for (var i = 0; i < tournament.length; i++) {
    //             var odd = tournament[i];
    //             if (!odd || !odd.id) continue;
    //             if (odd.id === newItem.id) {
    //               // Match! update value
    //               updateBetLineOdds(odd, newItem.pts, newItem.odd, selectedOddType);
    //             }
    //           }
    //         } else {
    //           for (const subType in oddType) {
    //             const odd = oddType[subType];
    //             if (!odd || !odd.id) continue;
    //             if (odd.id === newItem.id) {
    //               // Match! update value
    //               updateBetLineOdds(odd, newItem.cov, newItem.csv, selectedOddType);
    //             }
    //           }
    //         }
    //       }
    //     }
    //   });
    // });
    // }
  },
  setScoreData({ commit, state, rootState }, data) {
    if (state.propsData) {
      if (state.propsScore) {
        if (data.br_event_id === state.propsScore.br_event_id) {
          commit('setPropsScore', data);
        }
      }
    }
  },
  getStatsProps: ({ commit }, game) => {
    const hasMatchup = game ? game.has_matchup : false;

    if (hasMatchup) {
      _api
        .post('/game/matchstats', {
          sport_type: game.game_sport,
          home_team: game.home_team,
          visitor_team: game.visitor_team,
          league_title: game.game_league,
        })
        .then(res => {
          if (res.data.IsSuccess) {
            const data = res.data.Data ? res.data.Data : null;
            commit('setPropsStats', data);
          }
        })
        .finally(() => { });
    } else {
      commit('setPropsStats', {});
    }
  },
  setPropsParams: ({ commit }, params) => {
    commit('setPropsParams', params);
  },
};

export const propsStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
